var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApartment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1.72736V16.2727C2 16.4656 2.08429 16.6506 2.23431 16.787C2.38434 16.9234 2.58783 17 2.8 17H11.6V13.3637C11.6 12.9608 11.9568 12.6364 12.4 12.6364H14C14.4432 12.6364 14.8 12.9608 14.8 13.3637V17H17.2C17.4122 17 17.6157 16.9234 17.7657 16.787C17.9157 16.6506 18 16.4656 18 16.2727V7.54551C18 7.40479 17.9551 7.2671 17.8708 7.14911C17.7864 7.03112 17.6663 6.93792 17.5248 6.88079L3.1248 1.06264C3.00299 1.01344 2.86959 0.992695 2.73673 1.00228C2.60386 1.01186 2.47573 1.05147 2.36398 1.11751C2.25223 1.18356 2.1604 1.27393 2.09683 1.38044C2.03327 1.48694 1.99998 1.60619 2 1.72736ZM6 9.72731H7.6C8.0432 9.72731 8.4 10.0517 8.4 10.4546V13.3637C8.4 13.7666 8.0432 14.0909 7.6 14.0909H6C5.78783 14.0909 5.58434 14.0143 5.43431 13.8779C5.28429 13.7415 5.2 13.5565 5.2 13.3637V10.4546C5.2 10.0517 5.5568 9.72731 6 9.72731Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartment);
export default __webpack_public_path__ + "static/media/Apartment.18d0336004b47e29e2b1cf09c8f9b6bd.svg";
export { ForwardRef as ReactComponent };